import { jsx as _jsx } from "react/jsx-runtime";
/** Visual track for `toggle-switch-field` + `toggle-switch-field__input` (see main.scss). */
export default function ToggleSwitchTrack({ className }) {
    return (_jsx("span", { className: ["toggle-switch", className].filter(Boolean).join(" "), "aria-hidden": "true", children: _jsx("span", { className: "toggle-switch__thumb" }) }));
}
